import React from 'react';
import { StoreOption } from './Index';
import StoreSelect from './StoreSelect';

type Props = {
    open: boolean;
    email: string;
    scopes: string[];
    allScopes: string[];
    onEmailChange: (v: string) => void;
    onToggleScope: (scope: string) => void;
    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    submitting: boolean;
    feedback: { type: 'success' | 'error' | ''; text: string };
    stores: StoreOption[];
    storeId: number;
    onStoreChange: (v: number) => void;
};

export function UserCreateModal({
    open, email, scopes, allScopes, onEmailChange, onToggleScope, onClose, onSubmit, submitting, feedback,
    stores, storeId, onStoreChange,
}: Props) {
    if (!open) return null;

    return (
        <div className="modal" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>Create user</h2>
                <form onSubmit={onSubmit}>
                    <div className="scroll-area">
                        <div className="form-field">
                            <input
                                className="control"
                                type="email"
                                placeholder="user@domain.com"
                                value={email}
                                onChange={(e) => onEmailChange(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-field">
                            <label>Store</label>
                            <StoreSelect
                                options={stores}
                                value={storeId}
                                onChange={onStoreChange}
                            />
                        </div>

                        <div className="scopes-expanded">
                            {allScopes.map(sc => (
                                <label key={sc} className="chk">
                                    <input
                                        type="checkbox"
                                        checked={scopes.includes(sc)}
                                        onChange={() => onToggleScope(sc)}
                                    />
                                    <span>{sc}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    {feedback.text && (
                        <div className={`feedback-message ${feedback.type}`}>{feedback.text}</div>
                    )}

                    <div className="modal-actions">
                        <button
                            className={`btn-primary ${submitting ? 'loading' : ''}`}
                            type="submit"
                            disabled={submitting}
                        >
                            {submitting ? 'Creating...' : 'Create'}
                        </button>
                        <button
                            className="btn-secondary"
                            type="button"
                            onClick={onClose}
                            disabled={submitting}
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
